import 'jquery-exposed'
import 'jquery-easing'
import 'jquery-ujs/src/rails'
import init from 'base/init'
import store from 'base/store'
import { getIsAdminUser } from 'base/reducers/session/user'
import 'desktop/initializers/login_prompt'
import AdminBar from 'desktop/lib/admin_bar'
import Application from 'desktop/application'
import initBuilderKey from 'base/lib/singletons/initBuilderKey'

// E.desktop.Application is a singleton that lives in E.desktop.app
init()
  .then(() => {
    // TODO: move this initializer out when a better init system is established
    initBuilderKey()
    return new Application()
  })
  .then(() => {
    const { user } = store.getState().session
    if (getIsAdminUser(user)) {
      AdminBar.init()
    }
  })
